import jsonp from "jsonp";

import { unmaskCPF, unmaskCNPJ } from "./masks";

const validarCPF = (val) => {
  let cpf = unmaskCPF(val);
  if (
    !cpf ||
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  )
    return false;
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto == 10 || resto == 11) resto = 0;
  if (resto != parseInt(cpf.substring(10, 11))) return false;
  return true;
};

const validarCNPJ = (s) => {
  let cnpj = s.replace(/[^\d]+/g, "");

  // Valida a quantidade de caracteres
  if (cnpj.length !== 14) return false;

  // Elimina inválidos com todos os caracteres iguais
  if (/^(\d)\1+$/.test(cnpj)) return false;

  // Cáculo de validação
  let t = cnpj.length - 2,
    d = cnpj.substring(t),
    d1 = parseInt(d.charAt(0)),
    d2 = parseInt(d.charAt(1)),
    calc = (x) => {
      let n = cnpj.substring(0, x),
        y = x - 7,
        s = 0,
        r = 0;

      for (let i = x; i >= 1; i--) {
        s += n.charAt(x - i) * y--;
        if (y < 2) y = 9;
      }

      r = 11 - (s % 11);
      return r > 9 ? 0 : r;
    };

  return calc(t) === d1 && calc(t + 1) === d2;
};
const buscarCNPJ = (cnpj) => {
  return new Promise((resolve, reject) => {
    if (!validarCNPJ(cnpj)) {
      return reject("CNPJ inválido");
    }
    jsonp(
      `https://www.receitaws.com.br/v1/cnpj/${unmaskCNPJ(cnpj)}`,
      null,
      (err, data) => {
        if (err) {
          console.log(err);
          return reject(
            "Não foi possível buscar o CNPJ. Tente novamente daqui 1 minuto."
          );
        }
        if (data.status === "OK") {
          data.telefones = data.telefone
            .split("/")
            .map((t) => t.replace(/[^\d]+/g, ""));
          data.cnpj = data.cnpj.replace(/[^\d]+/g, "");
          data.cep = data.cep.replace(/[^\d]+/g, "");
          return resolve(data);
        }
        return reject(data.message);
      }
    );
  });
};

export { validarCPF, validarCNPJ, buscarCNPJ };
